import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';

import { ObjectItem, SubscriberService } from '@services';
import { FormFileUploaderComponent } from '@shared/components';
import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';
import { FormFileUploaderMetadata } from '@shared/components/form-file-uploader/model';
import { FormTranslatedFileUploaderConfig } from '@shared/components/form-translated-file-uploader/model';

import { assign, filter, find, flatten, map } from 'lodash';

@Component({
  selector: 'app-form-translated-file-uploader',
  templateUrl: './form-translated-file-uploader.component.html',
  styleUrls: ['./form-translated-file-uploader.component.scss'],
})
export class FormTranslatedFileUploaderComponent extends CustomFormComponent implements OnInit {
  public languages: { key: string; title: string; config: FormTranslatedFileUploaderConfig; value?: number }[];
  public config: FormTranslatedFileUploaderConfig;
  public isCollapsibleBlockActive: boolean;
  @ViewChildren(FormFileUploaderComponent) uploaderComponents: QueryList<FormFileUploaderComponent>;

  constructor(private subscriberService: SubscriberService) {
    super();
  }

  ngOnInit() {
    this.languages = map(this.subscriberService.getLanguages(true), (language) => {
      const currentValue = find(this.formValue, { language });
      const config = assign({}, this.config, {
        metadata: {
          ...this.config.metadata,
          language,
        },
        requestRemovingOnAction: true
      });

      return {
        key: language,
        title: this.subscriberService.getLanguageName(language),
        config,
        value: currentValue?.value
      }
    });
  }

  public emitValue() {
    const languages: { language: string; value: string; }[] = [];

    this.uploaderComponents.forEach((component) => {
      if (component.formValue && component.config.metadata.language) {
        languages.push({ language: component.config.metadata.language, value: component.formValue });
      }
    });

    this.formValue = languages?.length ? languages : '';
  }

  public upload(metadata?: FormFileUploaderMetadata): Promise<ObjectItem[]> {
    if (this.config.deferredUpload) {
      const uploadHandlers: Promise<ObjectItem[]>[] = [];

      this.uploaderComponents.forEach((uploaderComponent) => {
        uploaderComponent.config.metadata = assign({}, uploaderComponent.config.metadata, metadata);
        uploadHandlers.push(uploaderComponent.upload());
      });

      return Promise.all(uploadHandlers).then((result) => {
        return filter(flatten(result));
      });
    } else {
      return Promise.resolve([]);
    }
  }
}
